import { render, staticRenderFns } from "./JoinRegionModal.vue?vue&type=template&id=3ef7ebb0&scoped=true"
import script from "./JoinRegionModal.vue?vue&type=script&lang=js"
export * from "./JoinRegionModal.vue?vue&type=script&lang=js"
import style0 from "./JoinRegionModal.vue?vue&type=style&index=0&id=3ef7ebb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef7ebb0",
  null
  
)

export default component.exports